import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { forwardRef, } from 'react';
import { Skeleton } from '../../atoms/Skeleton';
import { useIsMobile } from '../../hooks';
import { useTheme } from '../../theme';
import { Card } from '../Card/Card';
import { MultiTab } from './MultiTab';
import { SingleTab } from './SingleTab';
const mobileTabStyle = (isActiveTab, theme) => ({
    borderBottomRightRadius: theme.shape.borderRadius,
    borderBottomLeftRadius: theme.shape.borderRadius,
    borderColor: theme.palette.primary.main,
    backgroundColor: isActiveTab ? '#2167ae26' : '', // see https://www.figma.com/file/FnTGQdoYCd9Bu6T0czvxWD/Styleguide-Intern?node-id=899%3A12710&mode=dev
    '&::after': {},
});
export const TabCard = forwardRef(function TabCard({ activeTab, tabs, onTabClick, isEditable, onEdit, isPremiumLoading = false, loading = false, }, ref) {
    const theme = useTheme();
    const isSingleTab = tabs.length === 1;
    const isMobile = useIsMobile() && !isSingleTab;
    const activeTabEntry = tabs.find((tab) => tab.id === activeTab);
    return (_jsxs("div", { children: [_jsx(Stack, { ref: ref, justifyContent: "flex-start", alignItems: "center", sx: { minWidth: 0, flexDirection: isMobile ? 'column' : 'row' }, children: tabs.map((tab) => {
                    const borderDefinition = !isMobile && activeTab === tab.id ? 1 : 0;
                    const borderRadiusDefinition = activeTab === tab.id ? theme.shape.borderRadius : 0;
                    return (_jsx(Box, { component: "button", onClick: () => {
                            if (onTabClick) {
                                onTabClick(tab.id);
                            }
                        }, sx: {
                            display: 'grid',
                            borderTopRightRadius: borderRadiusDefinition,
                            borderTopLeftRadius: borderRadiusDefinition,
                            borderTop: borderDefinition,
                            borderRight: borderDefinition,
                            borderLeft: borderDefinition,
                            borderBottom: 0,
                            textAlign: 'inherit',
                            backgroundColor: isSingleTab
                                ? theme.palette.groupPrimary.zurichWhite
                                : '#fff',
                            borderColor: isSingleTab
                                ? theme.palette.groupPrimary.zurichWhite
                                : theme.palette.primary.main,
                            cursor: onTabClick ? 'pointer' : 'initial',
                            flexGrow: 1,
                            width: '100%',
                            minHeight: '76px',
                            position: 'relative',
                            alignSelf: 'stretch',
                            alignItems: 'center',
                            ...(activeTab === tab.id && !isSingleTab
                                ? {
                                    '&::after': {
                                        left: '0px',
                                        position: 'absolute',
                                        background: '#fff', // fix background color per app
                                        content: '""',
                                        display: 'block',
                                        height: '1px',
                                        width: '100%',
                                        bottom: '-1px',
                                    },
                                }
                                : {}),
                            ...(isMobile
                                ? mobileTabStyle(activeTab === tab.id, theme)
                                : {}),
                        }, px: 106, py: isSingleTab ? 106 : 104, children: _jsxs(_Fragment, { children: [isPremiumLoading && (_jsx(Skeleton, { variant: "rectangular", children: isSingleTab ? (_jsx(SingleTab, { tab: tab })) : (_jsx(MultiTab, { tab: tab, activeTab: activeTab })) })), !isPremiumLoading &&
                                    (isSingleTab ? (_jsx(SingleTab, { tab: { ...tab, isEditable, onEdit } })) : (_jsx(MultiTab, { tab: tab, activeTab: activeTab })))] }) }, tab.id));
                }) }), activeTabEntry && (_jsx(_Fragment, { children: isMobile ? (_jsx(Card, { title: activeTabEntry.header, children: loading ? (_jsx(Skeleton, { variant: "rectangular", children: activeTabEntry.component })) : (activeTabEntry.component) })) : (_jsx(Box, { p: 106, sx: {
                        border: 1,
                        borderColor: isSingleTab
                            ? theme.palette.groupPrimary.zurichWhite
                            : theme.palette.primary.main,
                        backgroundColor: '#fff',
                    }, children: loading ? (_jsx(Skeleton, { variant: "rectangular", children: activeTabEntry.component })) : (activeTabEntry.component) })) }))] }));
});
